import React from "react"

export default function Temp(props) {
    const fahrenheit = Math.round(props.current.temp * (9/5) + 32);
    const celsius = Math.round(props.current.temp);
    
    //This button converts the hourly and daily units to Fahrenheit
    //This triggers a new API call,which updates all the information
    return(
        <div className="main-temp">
            <h1 id="temp">
                {props.unit === "celsius" ? celsius : fahrenheit}<button onClick={props.onClick} id="temp-scale">°{props.unit === "celsius" ? "C" : "F"}</button>
            </h1>
        </div>
    )
}